<template>
  <div class="couponProList sub-main">
    <rightNav></rightNav>
    <lateralNavigation2></lateralNavigation2>
    <div class='banxin'>
      <!--      <img class="banner" src="../../../static/image/dpbanner@2x.png" alt="">-->
      <div class="bannerBox"></div>
      <div class="content">
        <div>
          <div>
            <h3>{{categoryTitle}}</h3>

            <div class='sort'>
              <div>排序：</div>
              <div class='default' :class="index=='1'?'active':''" @click="defaultSort()">默认</div>
              <div class='price' :class="priceOrder=='asc'?'active':'active'" @click="priceSort()">
                价格
                <div class='arr'>
                  <div class='up' :class="priceOrder=='asc'?'low':''"></div>
                  <div class='down' :class="priceOrder=='desc'?'high':''"></div>
                </div>
              </div>
              <div class='sales' :class="salesOrder=='desc'?'active':''" @click="salesSort()">
                销量
                  <img v-show="salesOrder==''" src='../../../static/image/reduce@2x.png' alt='' />
                  <img v-show="salesOrder=='desc'" src='../../../static/image/reduce2@2x.png' alt='' />
                  <img v-show="salesOrder=='asc'" src='../../../static/image/reduce1@2x.png' alt='' />
              </div>
              <!-- <div class="priceBox" v-if="searchVal=='宝贝'">
                <div class='min'>¥<input type='number' v-model="minMoney" /></div>
                <div style='margin: 0 8px'>-</div>
                <div class='max'>¥<input type='number' v-model="maxMoney" /></div>
                <div class='btn' @click="priceSearch">确定</div>
                <div class='clear' @click="clearMoney">清空</div>
              </div> -->
            </div>

            <ProductList :productList='productList'></ProductList>
            <div v-if="noData" class="noproduct">
              <img src="../../../static/image/noorder@2x.png" alt="">
              <p class="fs20 font-color-999">该分类下没有商品～</p>
            </div>
          </div>
        </div>
        <el-pagination v-if="total>0" :current-page="page" :page-size="size" @current-change="handleCurrentChange" background layout='total, prev, pager, next' :total='total'>
        </el-pagination>
 <!--       <div class="shopitem">
          <div @click="goToProDetail(item)" class="likeProItem" v-for="item of productList" :key="item.id">

            <div class="main_shop1">
                  <div class="main_shop1_ite">
                      <img :src="item.image"  @click="toProductDetail(item)" alt="">
                  </div>
                  <div>
                      <p class="main_datail">{{item.storeName}}</p>
                      <p class="main_price"><span>¥</span>{{item.price}}<span></span>  <span class="originalPrice">¥{{ item.otPrice }}</span> </p>
                  </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import lateralNavigation2 from '../../components/base/lateralNavigation2'
import {mapMutations} from 'vuex'
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
import ProductList from '../../components/base/productList'
import likeList from '../product/likeList'
import rightNav from '../../components/canvasShow/rightNav'

export default {
  mixins: [listSearchMixin],
  components: {rightNav, ProductList, likeList, lateralNavigation2},
  data () {
    return {
      page: 1,
      size: 10,
      total: 0,
      productList: [],
      noData: false,
      categoryTitle: this.$route.query.name,
      minMoney: '',
      maxMoney: '',
      index: 1,
      type: '',
      volume: '',
      priceOrder: '',
      salesOrder: '',
      desc: 'desc',
      asc: 'asc'
    }
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: function () {
      let type = this.$route.query.id
      this.type = type
      this.categoryTitle = this.$route.query.name
      this.getCategoryProList(type)
    }
  },
  mounted () {
    console.log(this.$route.query.id, '3432432')
    let type = this.$route.query.id
    this.type = type
    this.getCategoryProList(type)
  },
  methods: {
    // 获取分类商品
    getCategoryProList (type) {
      const rLoading = this.openLoading()
      let self = this
      let condition = {
          'page': this.page,
          'limit': this.size,
          'type': type
        }
      let params = {
        url: api.getProductsByType + '?page=' + this.page + '&limit=' + this.size + '&type=' + type + '&priceOrder=' + this.priceOrder + '&salesOrder=' + this.salesOrder,
        method: 'GET',
        condition
      }
      self.sendReq(params, (res) => {
        if (res.success) {
           console.log('111', res)
          self.productList = res.data.list
          self.total = res.data.totalElements
          rLoading.close()
          if (!res.data.list) {
            self.noData = true
          }
        } else {
          self.$message({
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    // 分页器跳转
    handleCurrentChange (val) {
      this.page = val
      this.getCategoryProList(this.type)
    },
    toProductDetail (item) {
      this.setCurrentPro(item)
      this.$router.push({path: '/productDetail?productId='+item.id})
    },
    ...mapMutations({
      setComponentsData: 'SET_COMPONENTSDATA',
       setCurrentPro: 'SET_CURRENTPRO',
       show(cont){
            console.log(cont)
            this.isshow=cont;
        },
    }),
    // 默认排序
    defaultSort () {},
    // 价格排序
    priceSort () {
      this.salesOrder = ''
      if (this.priceOrder == 'asc') {
        // this.type = 1
        this.priceOrder = this.desc
      } else {
        // this.type = 2
        this.priceOrder = this.asc
      }
      // this.page = 1
      this.getCategoryProList(this.type)
    },
    // 销量排序
    salesSort () {
      this.priceOrder = ''
      if (this.salesOrder == 'asc') {
        // this.type = 1
        this.salesOrder = this.desc
      } else {
        // this.type = 2
        this.salesOrder = this.asc
      }
      // this.page = 1
      this.getCategoryProList(this.type)
    }
  }
}
</script>
<style lang = "scss" scoped>
	.sort {
    width: 100%;
    height: 63px;
    line-height: 27px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f1f1f1;
    color: #666666;
    padding-left: 20px;
      .default {
        margin-left: 20px;
        cursor: pointer;
      }
      .sales {
        margin-right: 20px;
        cursor: pointer;
        img{
          width: 9px;
          height: 16px;
          vertical-align: middle;
        }
	    }
      .price {
        display: flex;
        margin: 0 20px;
        cursor: pointer;
        .arr {
          vertical-align: middle;
          width: 12px;
          margin-left: 3px;
          .up {
            width: 0;
            height: 0;
            border: 6px solid transparent;
            border-bottom-color: #999999;
          }
          .down {
            width: 0;
            height: 0;
            border: 6px solid transparent;
            border-top-color: #999999;
            margin-top: 3px;
          }
	      }
	    }
	  .active{
	      color: #FF7800;
	      .arr{
	        .high{
	          border-top-color: #FF7800;
	        }
	        .low{
	          border-bottom-color: #FF7800;
	        }
	      }
	    }
	    .priceBox{
	      display: flex;
	      .min,
	      .max {
	        display: flex;
	        width: 100px;
	        height: 28px;
	        padding: 0 5px;
	        border: 1px solid #ccc;
	        box-sizing: border-box;
	        input {
	          width: 70px;
	          flex: 1;
	          outline: none;
	          border: none;
	        }
	      }
	      .btn {
	        width: 50px;
	        height: 28px;
	        border: 1px solid #ccc;
	        box-sizing: border-box;
	        cursor: pointer;
	        margin: 0 20px;
	      }
	      .clear {
	        cursor: pointer;
	        color: #999999;
	      }
	    }
	}
.couponProList{
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding-bottom: 143px;
  text-align: center;
  .banxin {
    width: 1252px;
    height: 100%;
    margin: 50px auto 0 auto;
    .head {
      width: 100%;
      height: 64px;
      line-height: 64px;
      font-size: 16px;
      display: flex;
      align-items: center;
      .all {
        margin-right: 20px;
      }
      .keyword {
        margin: 0 20px;
        color: #ff7800;
      }
      .arrow {
        background-image: url('../../../static/image/xiangyou@2x.png');
        width: 5px;
        height: 10px;
      }
    }
    .banner{
      width: 100%;
      height: 356px;
      margin-bottom: 25px;
    }
    .bannerBox {
      width: 100%;
      height: 10px;
      margin-bottom: 20px;
    }
    .content{
      background-color: #FFFFFF;
      width: 100%;
      /* padding: 0 45px 30px; */
      box-sizing: border-box;
      h3{
        font-size: 24px;
        font-weight: bold;
        //margin-bottom: 50px;
        //padding-top: 50px;
      }
      .noproduct{
        width: 100%;
        text-align: center;
        padding: 200px 0;
      }
      >>>.el-pagination{
        text-align: right;
		padding: 10px ;
        .el-pager{
          li:not(.disabled):hover{
            color: #FF7800;
          }
          li:not(.disabled).active{
            background-color: #FF7800;
          }
          li:not(.disabled).active:hover{
            color: #F4F4F5;
          }
        }
      }
      .shopitem{
          display: flex;
          // justify-content: space-around;
          .likeProItem{
            padding: 15px 10px;
            background-color: white;
          }
      }
    }
  }
}
.main_shop1_ite img:hover{
        transform: scale(1.4);
    }
    .main_shop1_ite img{
        width: 100%;
	      transition: transform 1.6s;
        margin-top: 0;
    }
    .main_youhui img{
        width: 100%;
    }
    .main_youhui{
        width: 360px;
        height: 127px;
        /* border: 1px solid red; */
        margin-top: 41px;
        /* padding: 17px 20px 0 20px; */
    }
    .main_im{
        margin-top: 80px;
    }
    .main_im img{
        width: 100%;
    }
    .shopitem{
        display: flex;
        // justify-content: space-around;
    }
    .main_price span{
        line-height: 12px;
        font-size: 8px;
        font-weight: normal;
    }
    .main_price{
        font-size: 14px;
        font-weight: bold;
        color: #FF7800;
        margin-left: 28px;
        /* display: flex; */
        /* align-items: flex-end;  */
        line-height: 24px;
        }
    .main_datail{

        font-family: Microsoft YaHei;
        margin-top: 20px;
        margin-bottom: 15px;
        font-weight: 400;
        width: 176px;
        height: 45px;
        line-height: 24px;
        margin-left: 28px;
        font-size: 16px;
        color: #666666;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .main_shop1_ite{
        width: 190px;
        height: 190px;
        margin: 0 auto;
        overflow: hidden;
		cursor: pointer;
    }
    .main_shop1_ite img{
        width: 100%;
    }
    .shopitem{
        flex-wrap: wrap;
    }
    .main_shop1{
        width: 230px;
        height: 320px;
        /* border: 1px solid red; */
        margin-top: 41px;
        // padding: 17px 20px 0 20px;
        padding-left: 0%;

    }
    .main_imgtop img{
        margin-top: -20px;
    }
    .main_sm{
        width: 96px;
        font-size: 18px;
        color: #666666;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .main_fl{
        display: flex;
        justify-content: space-between;
    }
    .main_bol{
        font-weight: bold;
        font-size: 30px;
    }
    .main{
        width:1250px;
        margin-top: 80px;
        margin: 0 auto;
        margin-top: 70px;
    }

    .likeProItem{
      padding: 15px 10px;
      background-color: white;
    }
    .main_shop1{
      margin-top: 0;
      //background-color: #f5f5f5;
      padding: 15px 0px;
    }
    .caidan{
      margin-left: 0;
    }
    .main_shop1_ite img:hover{
      transform: scale(1.4);
    }
    .main_im{
      margin-top: 50px;
    }
    .shopitem{
      margin-top: 50px;
    }
    .main{
      margin-top: 50px;
    }
    .main_im{
      margin-top: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/categoryProduct/index.vue